import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2f551026"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "project-initiator"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "tit"
};
const _hoisted_4 = {
  class: "name"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "i"
}, "发起人", -1));
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-down",
  src: "https://p6.moimg.net/md/icon/project_bottom_more.png"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompMembers = _resolveComponent("CompMembers");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onMembers && $options.onMembers(...args)),
    class: "project-initiator-icon",
    src: `${_ctx.$imgUrlFilter($props.user_info.user_icon || '', 152)}`
  }, null, 8, _hoisted_2), _createElementVNode("div", {
    class: "project-initiator-info",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onMembers && $options.onMembers(...args))
  }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString($props.user_info.nickname), 1), _hoisted_5]), $props.product_info.member_count > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString($props.product_info.member_count) + "个项目成员", 1), _hoisted_7])) : _createCommentVNode("", true)]), $props.user_info.shop_id ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "project-initiator-shop",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.goShop && $options.goShop(...args))
  }, "店铺")) : _createCommentVNode("", true), _createVNode(_component_CompMembers, {
    show: $data.showMembers,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => $data.showMembers = $event),
    pro_id: $props.product_info.id,
    pro_user_id: $props.user_info.user_id
  }, null, 8, ["show", "pro_id", "pro_user_id"])]);
}